"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isDefined(value) {
  return value !== undefined && value !== null;
}
module.exports = exports["default"];
//# sourceMappingURL=is-defined.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-input-range/lib/js/utils/is-defined.js
// module id = 1307
// module chunks = 0